<template lang="html">
  <div class="animationblock">
    <v-row class="levelSelector mt-5">
      <v-col cols="11" sm="8" md="12" class="text-left">
        <v-btn
          small
          @click="levelUp"
          :disabled="level==maxlevel || oneAnimationRunning"
          class="red white--text"
        >
        Szint <v-icon small>mdi-arrow-up</v-icon>
        </v-btn>
        <v-btn
          small
          @click="levelDown"
          :disabled="level==0 || oneAnimationRunning"
          class="blue white--text"
          >
        Szint <v-icon small>mdi-arrow-down</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center" justify-lg="start">
      <v-col cols="11" sm="8" md="12">
        <div class="exercises">
          <div class="levelDisplay">
            <h6 class="leveltitle">{{level}}.szint</h6>
            <p class="levelDescription">{{levelDescriptions[level]}}</p>
          </div>
          <div class="exercise" v-for="exercise in exercises[level]" :key="exercise.id">
            <v-btn :disabled="oneAnimationRunning" small class="indigo white--text" @click="animate(level,exercise.id)">
              <v-icon>mdi-play</v-icon>
            </v-btn>
            <div class="description" :class="{active: exercise.active}" :key="exercise.id">
              {{exercise.description}}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {exercises} from './animationexercises';
import {levelDescriptions} from './animationexercises';

export default {
  data(){
    return {
      level: 0,
      exercises,
      levelDescriptions,
      oneAnimationRunning: false,
      maxlevel: Object.keys(levelDescriptions).length-1
    }
  },
  created(){
    // console.log(this.maxlevel)
  },
  computed: {
    number:{
      get(){
        return this.$store.getters.displayNumber;
      },
      set(newValue){
        this.$store.dispatch('setDisplayNumber', newValue)
      }
    },
  },
  methods:{
    levelUp(){
      if (this.level<this.maxlevel) {
        this.level +=1
      }
    },
    levelDown(){
      if (this.level>0) {
        this.level -=1
      }
    },
    async animate(level,exercise){
      this.oneAnimationRunning = true;
      this.exercises[level][exercise].active = true
      if (level==0) {
        this.number = 0
        await this.sleep(1500)
        while (this.number<20) {
          this.number += 1
          await this.sleep(1500)
        }
      }
      else{
        let mysolution = exercises[level][exercise].solution
        let mysolutionparts = mysolution.split(' ')
        console.log(mysolutionparts)
        this.number = eval(mysolutionparts[0])
        await this.sleep(2500)
        this.number = eval(mysolutionparts[0]+mysolutionparts[1]+mysolutionparts[2])
        await this.sleep(2000)
        if (mysolutionparts.length>=5) {
          this.number = eval(mysolutionparts[0]+mysolutionparts[1]+mysolutionparts[2]+mysolutionparts[3]+mysolutionparts[4])
          await this.sleep(2000)
        }
        if (mysolutionparts.length>=7) {
          this.number = eval(mysolutionparts[0]+mysolutionparts[1]+mysolutionparts[2]+mysolutionparts[3]+mysolutionparts[4]+mysolutionparts[5]+mysolutionparts[6])
          await this.sleep(2000)
        }
        if (mysolutionparts.length>=9) {
          this.number = eval(mysolutionparts[0]+mysolutionparts[1]+mysolutionparts[2]+mysolutionparts[3]+mysolutionparts[4]+mysolutionparts[5]+mysolutionparts[6]+mysolutionparts[7]+mysolutionparts[8])
          await this.sleep(2000)
        }
      }

      this.oneAnimationRunning = false;
      this.exercises[level][exercise].active = false
    },
    sleep(ms){
      return new Promise(resolve => setTimeout(resolve, ms));
    },

  },
  watch:{
    oneAnimationRunning(){
      this.$store.dispatch('setAnimationRunning', this.oneAnimationRunning)
    }
  }
}
</script>

<style lang="scss" scoped>

.exercises {
  // margin-top: 15px;

  .levelDisplay{
    text-align: left;

    .leveltitle{
      font-weight: bold;
      font-size: 1rem;
      color: indigo;
    }
  }
  .exercise{
    margin-top: 10px;
    text-align: left;

    .description{
    display: inline-block;
    margin-left: 10px;

      &.active{
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
}

</style>
